import { resources } from "../../../../../../../core/models/resource/resources";

export const rrcLimitsCopyModalName: string = 'rrc-limits-copy';
export const rrcLimitsCopyResourceType = resources['rrc-limits'];
